import { z } from 'zod';
// Canonical recipient-address rule. The server's invite request schemas and
// the web invite surfaces' chip validation both read from here — when the
// two disagree, an address the client renders as a valid chip gets the whole
// batch rejected server-side with a VALIDATION error the sender can miss
// entirely (the 2026-06 "Send 10 invites did nothing" failure).
export const emailAddressSchema = z.string().email().max(254);
export function isValidEmailAddress(raw) {
    return emailAddressSchema.safeParse(raw).success;
}
// Per-request recipient cap for leader-initiated invite batches. Bounds the
// single transaction the handler runs (≈6 writes per recipient) and the
// email fan-out; mass imports belong to the admin CSV flow, which is paced
// by the worker. 200 ≈ 5× the largest human batch observed in prod (39,
// 2026-06) — high enough that a legitimate sender never hits it, low
// enough to stay one bounded transaction. Client and server both read this
// so the form can warn before the server would reject.
export const INVITE_BATCH_CAP = 200;
//# sourceMappingURL=address.js.map